import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { apiClient } from '../utils/api';

export interface HostTenantSummary {
  id: string; nome: string; piano: string; paid_plan: boolean; is_active: boolean;
  offers_total: number; offers_month: number; storage_configured: boolean;
  bucket: string | null; storage_bytes: number | null; storage_measured_at: string | null; storage_limit_mb: number; storage_limit_override_mb?: number | null; storage_error?: string | null;
}
export interface HostSummary { registered: number; paid_plan: number; free_plan: number; tenants: HostTenantSummary[] }
export const loadHostSummary = async (): Promise<HostSummary> => (await apiClient.client.get('/tenants/host-dashboard')).data;

export default function HostDashboard() {
  const query = useQuery({ queryKey: ['host-dashboard'], queryFn: loadHostSummary });
  if (query.isLoading) return <p role="status">Caricamento dashboard...</p>;
  if (query.isError) return <div role="alert">Impossibile caricare la dashboard. <button onClick={() => query.refetch()}>Riprova</button></div>;
  const data = query.data!;
  return <div className="space-y-6">
    <div><h1 className="text-2xl font-semibold">Dashboard piattaforma</h1><p className="text-gray-500">Tenant registrati e offerte create per impresa</p></div>
    <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
      {[
        ['Tenant registrati', data.registered], ['Piano a pagamento', data.paid_plan],
        ['Piano gratuito / test', data.free_plan], ['Offerte create', data.tenants.reduce((sum, t) => sum + t.offers_total, 0)],
      ].map(([label, value]) => <div key={label} className="bg-white rounded-lg shadow p-6"><p className="text-sm text-gray-500">{label}</p><p className="text-3xl font-semibold mt-2">{value}</p></div>)}
    </div>
    <p className="text-sm text-gray-500">La distinzione pagamento/test deriva dal prezzo del piano assegnato; non indica pagamenti incassati.</p>
    <div className="bg-white shadow rounded-lg overflow-x-auto"><table className="min-w-full text-sm text-left">
      <thead className="bg-gray-50"><tr>{['Tenant', 'Piano', 'Stato', 'Offerte totali', 'Offerte questo mese', 'Spazio bucket'].map(label => <th className="px-6 py-3" key={label}>{label}</th>)}</tr></thead>
      <tbody className="divide-y">{data.tenants.map(t => <tr key={t.id}>
        <td className="px-6 py-4"><Link to={`/tenants/${t.id}/edit`} className="text-primary-600">{t.nome}</Link></td>
        <td className="px-6 py-4">{t.piano}</td><td className="px-6 py-4">{t.is_active ? 'Attivo' : 'Sospeso'}</td>
        <td className="px-6 py-4">{t.offers_total}</td><td className="px-6 py-4">{t.offers_month}</td>
        <td className="px-6 py-4">{t.storage_bytes === null ? (t.storage_configured ? 'Da misurare' : 'Non configurato') : `${(t.storage_bytes / 1048576).toLocaleString('it-IT', { maximumFractionDigits: 2 })} MB`}</td>
      </tr>)}</tbody>
    </table>{data.tenants.length === 0 && <p className="p-6 text-gray-500">Nessun tenant registrato.</p>}</div>
  </div>;
}
